import type { ProductVariants } from '../types';
import { getProductsByMasterId } from '../utils';
import { getUniqueVariants } from '../utils/getUniqueVariants';
import { mapProductVariant } from '../utils/mapProductVariant';

export const getProductVariants = async (masterId: string): Promise<ProductVariants> => {
    const products = await getProductsByMasterId(masterId);

    const variants = products.map(mapProductVariant);

    const uniqueVariants = getUniqueVariants(variants);

    return { variants, uniqueVariants };
};
